import { render, staticRenderFns } from "./NormalTable.vue?vue&type=template&id=436c7658&scoped=true&"
import script from "./NormalTable.vue?vue&type=script&setup=true&lang=ts&"
export * from "./NormalTable.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./NormalTable.vue?vue&type=style&index=0&id=436c7658&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "436c7658",
  null
  
)

export default component.exports